export const isTpaByAppType = (appDataType: string) => !(appDataType === 'wixapps' || appDataType === 'appbuilder')
